module.exports = __webpack_public_path__ + "img/4.afdbc5b1.jpg";